export default "__VITE_ASSET__CpQcnzui__"